import { DeepPartial } from 'utility-types'

import { MessageTemplateAttachment, MessageTemplateHeader } from 'apps/whatsApp/core/constants'
import {
  MessengerMessageTemplateHeader,
  MessengerMessageTemplateHeaderType,
  MessengerMessageTemplateHeaderTypeAttachment,
} from 'shared/api/requests/messenger/schemas'

export const getIsAttachmentMessageTemplateHeader = (
  header?: DeepPartial<MessageTemplateHeader> | DeepPartial<MessengerMessageTemplateHeader>,
): header is MessengerMessageTemplateHeaderTypeAttachment => {
  return Boolean(
    !Array.isArray(header) &&
      header?.type &&
      [MessageTemplateAttachment.IMAGE, MessengerMessageTemplateHeaderType.IMAGE].includes(
        header.type,
      ),
  )
}
